<header class="header">
  <div class="content">
    <div class="header__block row">
      <div class="header__arrow col image"></div>
      <div class="header__title col">דשבורד</div>
      <div class="header__burger col image"></div>
    </div>
  </div>

  <div class="report-table__row">
    <div
      class="header__search header__search_small"
      style="
        width: 99%;
        margin: auto;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
      "
    >
      <ng-container *ngIf="section1 === true">
        <form [formGroup]="form">
          <input
            class="header__search-input"
            type="text"
            placeholder="חפש לקוח"
            formControlName="Name"
          />
        </form>
        <button
          (click)="changeSubjectBooleanValue()"
          class="english-hebrew-button header__search-input"
          [ngClass]="{ active: translateEnglishCharactersToHebrew$ | async }"
        >
          {{ buttonMessage$ | async }}
        </button>
      </ng-container>
    </div>
  </div>
</header>

<section
  class="report-table"
  style="margin-top: 50px; text-align: center"
  *ngIf="section2 === true"
>
  <div class="content">
    <div
      class="report-table__row report-table__row_full-width"
      style="width: 300px; margin: auto"
    >
      <form [formGroup]="form">
        <div>שם משתמש:</div>
        <input
          type="text"
          formControlName="User"
          style="height: 30px; border: black 1px solid; font-size: 20px"
        />
        <div>סיסמא:</div>
        <input
          type="text"
          formControlName="Pass"
          style="height: 30px; border: black 1px solid; font-size: 20px"
        />
        <br />
        <button
          type="submit"
          style="width: 70px; height: 25px; margin-top: 15px"
          (click)="Login()"
        >
          אישור
        </button>
      </form>
    </div>
  </div>
</section>

<section class="report-table" *ngIf="section1 === true">
  <div class="content">
    <div
      style="
        text-align: center;
        font-size: 15px;
        font-weight: 400;
        margin-bottom: 12px;
        margin-top: 12px;
      "
    >
      <span> בדיקת סטרינג - </span>
      <u>
        <a href="http://stringcheck.s3-website.eu-central-1.amazonaws.com"
          >http://stringcheck...
        </a></u
      >
    </div>

    <div
      style="
        text-align: center;
        font-size: 15px;
        font-weight: 400;
        margin-bottom: 12px;
        margin-top: 12px;
      "
    >
      <span> קישור ישן - </span>
      <u>
        <a href="http://client.mobility-ltd.com"
          >www.client.mobility-ltd.com
        </a></u
      >
    </div>

    <div
      style="
        text-align: center;
        font-size: 15px;
        font-weight: 400;
        margin-bottom: 12px;
        margin-top: 12px;
      "
    >
      <span> קישור ראשי מאובטח- </span>
      <u> <a href="https://mobilityltd.net">https://mobilityltd.net </a></u>
    </div>

    <div
      style="
        text-align: center;
        font-size: 15px;
        font-weight: 400;
        margin-bottom: 12px;
        margin-top: 12px;
        flex-direction: column;
        display: flex;
      "
    >
      <app-button *ngIf="customersDisplay$ | async">
        הורד דוח סוכנים פעילים
      </app-button>
      <ng-container *ngIf="_excel.anyRequests$ | async as anyRequests">
        <span *ngIf="anyRequests">מכין דוח...</span>
        <span>
          {{ _excel.totalRequestsMade$ | async }} מתוך {{ anyRequests }}</span
        >
      </ng-container>
      <ng-container *ngIf="_excel.downloadComplete$ | async">
        <span> דוח מוכן!</span>
      </ng-container>
    </div>

    <!-- <div style="text-align: center;font-size: 15px;font-weight: 400;margin-bottom: 12px;margin-top: 12px;">
  <span>   גיבוי באמזון - </span> <u> <a href="http://mobilitydesignnewtest.s3-website.eu-central-1.amazonaws.com" >www.mobilitydesignnewtest... </a></u>
</div> -->

    <div
      style="
        text-align: center;
        font-size: 15px;
        font-weight: 400;
        margin-bottom: 12px;
        margin-top: 12px;
      "
    >
      <span> הוסף לקוח - </span> <u> <a href="addclient">הוסף +</a></u>
    </div>
    <div
      style="
        text-align: center;
        font-size: 15px;
        font-weight: 400;
        margin-bottom: 12px;
        margin-top: 12px;
      "
    >
      <span *ngIf="customersDisplay$ | async">
        סה"כ לקוחות: {{ totalCustomers$ | async }}
      </span>
    </div>

    <div class="report-table__row report-table__row_full-width">
      <table class="report-table__table" cellspacing="0">
        <thead class="report-table__table-head">
          <tr>
            <th
              class="report-table__table-head-quantity no-sort"
              style="width: 50px"
            >
              #
            </th>
            <th
              class="report-table__table-head-quantity"
              style="width: 200px"
              (click)="sortMain('CustName')"
            >
              שם לקוח
            </th>
            <th
              class="report-table__table-head-quantity"
              (click)="sortMain('CustNum')"
            >
              מספר לקוח
            </th>
            <th class="report-table__table-head-quantity no-sort">עריכה</th>
            <th class="report-table__table-head-quantity no-sort">דשבורד</th>
            <th class="report-table__table-head-quantity no-sort">סוכנים</th>
            <th
              class="report-table__table-head-quantity"
              (click)="sortMain('LastPoll')"
            >
              תשובה אחרונה
            </th>
            <th
              class="report-table__table-head-quantity"
              (click)="sortMain('sslTokef')"
            >
              ssl
            </th>
          </tr>
        </thead>
        <tbody class="report-table__table-body">
          <tr *ngFor="let c of customersDisplay$ | async; let i = index">
            <td
              class="report-table__table-head-quantity"
              style="padding: 20px; width: 50px"
            >
              {{ i + 1 }}.
            </td>
            <td
              class="report-table__table-head-quantity"
              style="color: green"
              *ngIf="c.CustDomain !== ''"
            >
              <a href="{{ c.CustDomain }}" style="color: green">{{
                c.CustName
              }}</a>
            </td>
            <td
              class="report-table__table-head-quantity"
              *ngIf="c.CustDomain === ''"
            >
              {{ c.CustName }}
            </td>
            <td
              class="report-table__table-head-quantity"
              style="color: green"
              *ngIf="
                c.CustServer.slice(-4) === '1000' ||
                c.CustServer.slice(-4) === '6001'
              "
            >
              {{ c.CustNum }}
            </td>
            <td
              class="report-table__table-head-quantity"
              style="color: red"
              *ngIf="
                c.CustServer.slice(-4) !== '1000' &&
                c.CustServer.slice(-4) !== '6001'
              "
            >
              {{ c.CustNum }}
            </td>
            <td class="report-table__table-head-quantity" (click)="CustInfo(c)">
              <u>ערוך</u>
            </td>
            <td
              class="report-table__table-head-quantity"
              (click)="MoveToDashbord(c)"
            >
              <u>דשבורד</u>
            </td>

            <td class="report-table__table-head-quantity">
              {{ c.ActiveAgents }}
            </td>
            <td
              class="report-table__table-head-quantity"
              [ngStyle]="{
                color: hasServerReceivedResponseInAcceptableTime(c.LastPoll)
                  ? 'green'
                  : 'red'
              }"
            >
              {{ c.LastPoll | date : "dd/MM/yyyy HH:mm:ss" : "GMT" }}
            </td>
            <td
              class="report-table__table-head-quantity"
              [ngStyle]="{
                color: hasServerReceivedResponseInAcceptableTime(c.sslTokef)
                  ? 'green'
                  : 'red'
              }"
            >
              {{ c.sslTokef | date : "dd/MM/yyyy HH:mm:ss" : "GMT" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
